import { Api } from "@/api/Api";
import type { Profile, ProfileCreate, ProfileUpdate, SlimProfile } from "@mm/metx-workbench.meteomatics.com";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const importProfile = createAsyncThunk("api/profile/import", async (payload: { data: Profile }, _thunkAPI) => {
  return await Api.profile.v1ProfileImportV2({ requestBody: payload.data }).then((profile) => {
    return profile;
  });
});

export const fetchSlimProfiles = createAsyncThunk("api/all-profiles-slim", async (_thunkApi) => {
  return await Api.profile.v2SlimProfileListAll({}).then((profiles) => {
    return profiles;
  });
});

export const createProfile = createAsyncThunk("api/profile/create", async (payload: ProfileCreate, _thunkAPI) => {
  return await Api.profile.v2ProfileCreate({ profileCreate: payload }).then((profile) => {
    return profile;
  });
});

export const updateProfile = createAsyncThunk(
  "api/profile/update",
  async (payload: { profileId: Profile["id"]; data: ProfileUpdate; isLocked?: boolean }) => {
    return await Api.profile.v2ProfileUpdate({
      profileId: payload.profileId,
      profileUpdate: payload.data,
    });
  },
  //   If condition is true, it does everything as normal, but if its false, it will get short-circuited and canceled
  {
    condition: (payload) => !payload.isLocked,
  },
);
export const setProfileTags = createAsyncThunk(
  "api/profile/setTags",
  async (payload: { profileId: number; tags: string[] }, _thunkAPI) => {
    const tags = await Api.profile.setTags({ profileId: payload.profileId, bodySetTags: { tags: payload.tags } });
    const filteredTags = tags.filter((tag): tag is string => tag !== null);
    return { profileId: payload.profileId, tags: filteredTags };
  },
);

export const duplicateDashboard = createAsyncThunk(
  "api/profile/duplicate",
  async (payLoad: { profileId: number }, _thunkAPI) => {
    return await Api.profile
      .v2ProfileDuplicate({ profileId: payLoad.profileId })
      .then((duplicatedDashboard: SlimProfile) => {
        return duplicatedDashboard;
      })
      .catch((error) => {
        console.error("Failed to duplicate dashboard:", error);
        throw error;
      });
  },
);

export const copyMarketplaceDashboard = createAsyncThunk(
  "api/marketplace/copy",
  async (profileId: number, _thunkAPI) => {
    return await Api.marketplace.copyMarketplaceDashboard({ profileId });
  },
);

export const removeProfile = createAsyncThunk(
  "api/profile/delete",
  (payload: { profileId: Profile["id"] }, _thunkAPI) => {
    return Api.profile.v2ProfileDelete({ profileId: payload.profileId }).then(() => {
      return payload.profileId;
    });
  },
);
